import { createContext, useContext } from "react";

interface CollapsableContextValue {
    show: boolean;
    toggle: () => void;
}

export const CollapsableContext = createContext<CollapsableContextValue>({
    show: false,
    toggle: () => {}
});

const useCollapsable = () => {
    const context = useContext(CollapsableContext);
    if (!context) {
        throw new Error("Collapsable compound components must be used within Collapsable");
    }
    return context;
};

export default useCollapsable;